<template lang="">
  <main id="main" style="margin-top: 80px">
    <WeddingInvitationEditForm :weddingInvitationSeq=weddingInvitationSeq />
  </main>
</template>
<script>
import WeddingInvitationEditForm from '@/components/wedding/WeddingInvitationEditForm.vue';

export default {
    props: {
        weddingInvitationSeq: {
            type: String,
            required: true
        }
    },

    components: {
        WeddingInvitationEditForm
    }
}
</script>
<style lang="">
    
</style>